import React from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { makeStyles } from '@material-ui/core/styles';
import {
  AccountCircleTwoTone,
  Schedule,
  EventNoteTwoTone,
  ExitToAppRounded,
} from '@material-ui/icons';
import Divider from '@material-ui/core/Divider';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    zIndex: 100,
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  icon: {
    marginRight: 5,
  },
}));

export default function HeaderMenuList(props) {
  const classes = useStyles();
  const history = props.history;
  const user = props.user;
  const [open, setOpen] = React.useState(false);
  const [openClipping, setOpenClipping] = React.useState(false);
  const anchorRef = React.useRef(null);

  const hasUserCalendarToken = user.calendar_token
    ? `/novo-recorte`
    : `/sobre-recorte`;

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const openClippingModal = () => {
    setOpenClipping(true);
  };

  const closeClippingModal = () => {
    setOpenClipping(false);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  function onItemClick(event) {
    history.push(event);
    setOpen(true);
  }

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  return (
    <div
      className="header-menu-user-logged-in component-focus flex-row align-center
    justify-center self-align-center self-justify-center"
      onClick={handleToggle}
    >
      <div
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        className="flex-column align-end justify-center"
        style={{ marginRight: 10 }}
      >
        <span
          style={{
            color: '#FFFFFF',
            fontSize: 16,
            fontWeight: 'bold',
          }}
        >
          {user.name}
        </span>
        <span style={{ color: '#AAAAAA', fontSize: 14 }}>{user.email}</span>
      </div>
      {!user.image ? (
        <span
          className="flex-row align-center justify-center"
          style={{
            width: 40,
            height: 40,
            borderRadius: 40,
            backgroundColor: '#AAAAAA',
            fontWeight: 'bold',
          }}
        >
          {user.name.substr(0, 1).toUpperCase()}
        </span>
      ) : (
        <img
          src={user.image}
          alt="Imagem não encontrada"
          style={{
            width: 40,
            height: 40,
            borderRadius: 40,
            backgroundColor: 'transparent',
          }}
        />
      )}
      <Popper
        className={classes.root}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper className={classes.paper}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="menu-list-grow"
                  onKeyDown={handleListKeyDown}
                >
                  <MenuItem onClick={() => onItemClick(hasUserCalendarToken)}>
                    <Schedule className={classes.icon} />
                    Novo Recorte
                  </MenuItem>
                  <MenuItem onClick={() => onItemClick(`/acompanhar-agenda`)}>
                    <EventNoteTwoTone className={classes.icon} />
                    Acompanhar Agenda
                  </MenuItem>
                  <Divider style={{ marginTop: 25, marginBottom: 25 }} />
                  <MenuItem onClick={() => onItemClick(`/perfil`)}>
                    <AccountCircleTwoTone className={classes.icon} />
                    Perfil
                  </MenuItem>
                  <MenuItem onClick={() => onItemClick(`/logout`)}>
                    <ExitToAppRounded className={classes.icon} />
                    Sair
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}
